import React from 'react'
import { Player } from "../Player/Player";
import DropZone from "react-drop-zone";
import { DragDropContainer } from 'react-drag-drop-container';
import 'react-drop-zone/dist/styles.css';
import "./Music2.css";

const TemplateMusic = ({id, addNewElement, data}) => {
    return (
        <div id={id}>
            <DropZone accept=".mp3, .ogg" onDrop={addNewElement}>
                {({over}) =>over?
                    <div className='DropZone'>Upuść tutaj</div>:
                    <div className='button' >Dodaj nowy dzwięk</div>
                }
            </DropZone>
            <div className='box'>
                { data.map((music)=>{
                        return (
                            <DragDropContainer
                                key={music.id}
                                dragData={music}
                            >
                                <Player
                                    prefix={id}
                                    music={music}
                                />
                            </DragDropContainer>
                        )
                    }
                )}
            </div>
        </div>
    );
}

export default TemplateMusic;